import React, { useState } from 'react';
import { Modal, Form, Input, Button, Dropdown } from 'semantic-ui-react';
import { StyledModal, StyledConfirm } from './SharedStyles';
import { getTodayISO } from '../utils/dateUtils';

const sizeOptions = [
  { key: '1', text: 'Small', value: 1 },
  { key: '2', text: 'Medium', value: 2 },
  { key: '3', text: 'Large', value: 3 },
];

const TaskEditForm = ({ open, formData, onChange, onSubmit, onCancel, onDelete, delegates, selectedDelegateUserIds, onDelegatesChange }) => {
  const todayISO = getTodayISO();
  const [confirmDelete, setConfirmDelete] = useState(false);

  const delegateOptions = (delegates || []).map(d => ({
    key: d.delegate_id,
    text: d.delegate_name,
    value: d.delegate_id,
    description: d.delegate_email || d.mobile || '',
  }));

  return (
    <>
      <StyledModal open={open} onClose={onCancel}>
        <Modal.Header>Edit Task</Modal.Header>
        <Modal.Content>
          <Form onSubmit={onSubmit}>
            <Form.Field>
              <label>Label</label>
              <Input name="label" value={formData.label} onChange={onChange} />
            </Form.Field>
            <Form.Field>
              <label>Content</label>
              <Input name="content" value={formData.content} onChange={onChange} maxLength={250} />
            </Form.Field>
            <Form.Field>
              <label>URL</label>
              <Input name="url" value={formData.url} onChange={onChange} />
            </Form.Field>
            <Form.Field>
              <label>Due Date</label>
              <Input type="date" name="due" value={formData.due} onChange={onChange} min={todayISO} />
            </Form.Field>
            <Form.Field>
              <label>Size</label>
              <Form.Select name="size" options={sizeOptions} value={formData.size} onChange={onChange} placeholder="Select size" />
            </Form.Field>
            {delegates && delegates.length > 0 && (
              <Form.Field>
                <label>Delegates</label>
                <Dropdown
                  placeholder="Select delegates"
                  fluid
                  multiple
                  search
                  selection
                  options={delegateOptions}
                  value={selectedDelegateUserIds || []}
                  onChange={(e, { value }) => onDelegatesChange(value)}
                />
              </Form.Field>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          {onDelete && (
            <Button color="red" floated="left" onClick={() => setConfirmDelete(true)}>
              Delete
            </Button>
          )}
          <Button onClick={onCancel}>Cancel</Button>
          <Button positive onClick={onSubmit}>Save</Button>
        </Modal.Actions>
      </StyledModal>
      <StyledConfirm
        open={confirmDelete}
        header="Delete Subtask"
        content="This will permanently delete this subtask. This cannot be undone."
        confirmButton="Delete"
        onCancel={() => setConfirmDelete(false)}
        onConfirm={() => { setConfirmDelete(false); onDelete(); }}
      />
    </>
  );
};

export default TaskEditForm;
